import React from "react";

export const MFAInstructions = () => {
  const helpArticleUrl = "https://intercom.help/breathehr/en/articles/9076956-setting-up-two-factor-authentication-2fa";

  return (
    <div className="flex flex-col gap-6 items-start w-full">
      <h1 className="font-bold leading-9 font-rubik w-full" style={{ fontSize: "30px", lineHeight: "36px", color: "#0a0a0a" }}>
        Set up two-factor authentication (2FA)
      </h1>
      
      <div className="flex flex-col gap-6 text-sm leading-5 font-inter" style={{ color: "#0a0a0a" }}>
        <p>
          Your organisation has switched on <strong className="font-bold">two-factor authentication (2FA)</strong>{" "}
          to add an extra layer of security to your Breathe account. You&apos;ll now need to
          provide a unique code - as well as your email and password - each time you log in.
        </p>
        
        <p>
          You&apos;ll need an authenticator app (e.g. Microsoft Authenticator, Google Authenticator,
          Twilio Authy) on your phone - this is where you&apos;ll get your unique code each time you
          log in to Breathe.
        </p>
        
        <p>
          You&apos;ll need to set up 2FA before you can log in again - click on the button below
          for instructions on how to get started.
        </p>
        
        <p>
          If you have any questions, speak to your Breathe admin user or check out our knowledge-base.
        </p>
      </div>

      <div className="flex items-center justify-center w-full">
        <p className="text-sm text-center text-neutral-950 font-rubik">
          Having trouble? Set up instructions{" "}
          <a
            href={helpArticleUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="underline decoration-solid"
          >
            here
          </a>
        </p>
      </div>
    </div>
  );
};
